'use client';

import { useState, useEffect } from 'react';
import { useLanguage } from '@/contexts/LanguageContext';

interface Stat {
  label: string;
  value: string;
  change: string;
  trend: 'up' | 'down' | 'neutral';
  icon: string;
}

const StatsOverview = () => {
  const [isHydrated, setIsHydrated] = useState(false);
  const { t } = useLanguage();

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  const stats: Stat[] = [
    {
      label: t('dashboard.totalPortfolioValue'),
      value: '$12.4M',
      change: '+8.2%',
      trend: 'up',
      icon: 'CurrencyDollarIcon',
    },
    {
      label: t('dashboard.activeInvestments'),
      value: '47',
      change: '+12',
      trend: 'up',
      icon: 'BriefcaseIcon',
    },
    {
      label: t('dashboard.averageROI'),
      value: '32.5%',
      change: '+4.3%',
      trend: 'up',
      icon: 'ArrowTrendingUpIcon',
    },
    {
      label: t('dashboard.monthlyReturns'),
      value: '$847K',
      change: '+15.7%',
      trend: 'up',
      icon: 'ChartBarIcon',
    },
  ];

  if (!isHydrated) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {[1, 2, 3, 4].map((i) => (
          <div key={i} className="bg-card rounded-lg shadow-card p-6 border border-border animate-pulse">
            <div className="h-6 bg-muted rounded w-1/2 mb-4"></div>
            <div className="h-8 bg-muted rounded w-3/4 mb-2"></div>
            <div className="h-4 bg-muted rounded w-1/3"></div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="space-y-4">
    </div>
  );
};

export default StatsOverview;